import { postBlock } from '../api/postBlock';

const setPostBlock = (params) => {
    return async (dispatch, getState) => {
        try {
            await postBlock(params);
            
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostBlock
}